import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import type { SxProps, Theme } from '@mui/material/styles'
import { Icon } from '@iconify/react'
import { bhyveNavTokens as T } from './bhyveNavTokens'

export type BhyveAppFooterProps = {
  sx?: SxProps<Theme>
}

/**
 * Global app footer (desktop): BHYVE mark + legal strip. Responsive variants later.
 */
export const BhyveAppFooter: React.FC<BhyveAppFooterProps> = ({ sx }) => {
  const year = new Date().getFullYear()

  return (
    <Box
      data-bhyve-app-footer
      component='footer'
      sx={{
        gridRow: 4,
        zIndex: theme => theme.zIndex.appBar - 1,
        px: 2,
        py: 1.25,
        borderTop: `1px solid ${T.secondaryBarBorder}`,
        bgcolor: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        flexWrap: 'wrap',
        minHeight: 48,
        boxShadow: '0 -1px 0 rgba(23, 23, 23, 0.06)',
        ...(sx ?? {})
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          maxWidth: '100%',
          gap: 1.5,
          flexWrap: 'wrap'
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }} aria-hidden />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0, justifyContent: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
            <Icon icon='mdi:hexagon-multiple' width={22} height={22} color={T.brandYellow} />
            <Typography
              component='span'
              sx={{
                fontWeight: 700,
                fontSize: 13,
                letterSpacing: '0.06em',
                color: T.sidebarText,
                lineHeight: 1
              }}
            >
              BHYVE
            </Typography>
          </Box>
          <Typography variant='caption' sx={{ color: T.sidebarTextMuted, fontSize: 12 }}>
            © {year} GYG. All rights reserved.
          </Typography>
        </Box>
        <Box
          data-bhyve-footer-trailing
          sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            minWidth: 0,
            minHeight: 36
          }}
        />
      </Box>
    </Box>
  )
}
